import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardItemCondensed from "src/components/card/SfxCardItemCondensed.vue"
import { ItemCardData } from "src/util/types/dataModels/item"
import { PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogItemClone',
  props: {
  item: {
    type: Object as PropType<ItemCardData>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const { t } = useI18n()

const title = t("sfxDialogItemClone.title")
const content = t("sfxDialogItemClone.content")
const btnClone = t("sfxButtons.btn_confirm")
const btnCancel = t("sfxButtons.btn_cancel")

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-mb-sm" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-none" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(content) }, null, 8, _hoisted_1),
              _createVNode(SfxCardItemCondensed, {
                item: props.item,
                clickable: false,
                class: "q-my-lg"
              }, null, 8, ["item"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-pt-none q-mx-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(btnCancel),
                class: "col"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _unref(btnClone),
                class: "col"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})